import React, { useState, useEffect } from 'react';
import { getCertificatesForShipment } from '../lib/api';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { FileText, Loader2, Download, AlertTriangle } from 'lucide-react';
import { Badge } from './ui/badge';

export function ContratoGenerator({ mbl, shipment }) {
  const [contract, setContract] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!mbl) return;
    setLoading(true);
    getCertificatesForShipment(mbl)
      .then(res => {
        const contracts = res.data || [];
        // Pick the first active contract with a file
        const active = contracts.find(c => c.file_url) || contracts[0] || null;
        setContract(active);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [mbl]);

  if (loading) return null;

  if (!contract || !contract.file_url) {
    return (
      <Button variant="outline" size="sm" disabled data-testid="generate-contrato-btn" title="No hay contrato asignado para esta importadora/proveedor">
        <FileText size={14} className="mr-1.5 opacity-50" />
        Sin Contrato
      </Button>
    );
  }

  const isExpired = contract.status === 'expired';
  const isExpiring = contract.status === 'expiring_soon';

  return (
    <a href={contract.file_url} target="_blank" rel="noopener noreferrer" className="inline-flex">
      <Button
        variant="outline"
        size="sm"
        data-testid="generate-contrato-btn"
        className={isExpired ? 'border-red-500/30 text-red-400' : isExpiring ? 'border-amber-500/30 text-amber-400' : ''}
      >
        <Download size={14} className="mr-1.5" />
        Contrato
        {isExpired && (
          <Badge variant="destructive" className="ml-1.5 text-[10px] px-1 py-0">
            <AlertTriangle size={8} className="mr-0.5" />Vencido
          </Badge>
        )}
        {isExpiring && (
          <Badge variant="outline" className="ml-1.5 text-[10px] px-1 py-0 border-amber-500/30 text-amber-400">
            {contract.days_until_expiration}d
          </Badge>
        )}
      </Button>
    </a>
  );
}
